/**
 * Single source of truth for metric RAG (Red / Amber / Green) banding.
 *
 * Banding is on GOAL ATTAINMENT (value / goal * 100):
 *   attainment >= GREEN_AT  -> green  (on track)
 *   attainment >= AMBER_AT  -> amber  (at risk)
 *   below AMBER_AT          -> red    (off track)
 *
 * Tune the two thresholds here and every visual (bullet bars, rings,
 * summary values) updates together.
 */

export const GREEN_AT = 100; // goal met or exceeded → green
export const AMBER_AT = 75;  // 75% of goal up to goal → amber; below 75% of goal → red

export const STATUS_COLORS = {
  green: '#037f0c',
  amber: '#bf7300',
  red: '#d91515',
} as const;

export type MetricStatus = keyof typeof STATUS_COLORS;

export function getMetricStatus(value: number, goal: number): MetricStatus {
  if (goal <= 0) return 'green';
  const attainment = (value / goal) * 100;
  if (attainment >= GREEN_AT) return 'green';
  if (attainment >= AMBER_AT) return 'amber';
  return 'red';
}

export function getMetricStatusColor(value: number, goal: number): string {
  return STATUS_COLORS[getMetricStatus(value, goal)];
}
